import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { StringHelper } from 'src/app/helpers/string-helper';
import Contact from 'src/app/model/Contact/contact';
import { Project } from 'src/app/model/project/project';

export class IPBoardCustomBoardPhoneNumberPickerHelper {
  private constructor() {}

  public static readonly OTHER_PHONE_NUMBER_ID = 'Andere';

  private static ALTERNATIVE: PhoneNumberOption = {
    id: IPBoardCustomBoardPhoneNumberPickerHelper.OTHER_PHONE_NUMBER_ID,
    label: 'Ander telefoonnummer'
  };

  static getPhoneNumberOptions(
    project: Project,
    otherContacts: Contact[]
  ): PhoneNumberOption[] {
    if (
      project == null ||
      (!CollectionHelper.isPopulated(project.projectContacts) &&
        !CollectionHelper.isPopulated(otherContacts))
    ) {
      return [IPBoardCustomBoardPhoneNumberPickerHelper.ALTERNATIVE];
    }

    const toReturn: PhoneNumberOption[] = [];

    const firstProjectContact =
      project.projectContacts == null ? null : project.projectContacts[0];
    if (
      firstProjectContact != null &&
      firstProjectContact.company != null &&
      CollectionHelper.isPopulated(firstProjectContact.company.telephones)
    ) {
      firstProjectContact.company.telephones.forEach(t => {
        toReturn.push({
          id: t.number,
          label: t.number
        });
      });
    }

    if (CollectionHelper.isPopulated(project.projectContacts)) {
      project.projectContacts.forEach(pc => {
        if (
          pc.contact != null &&
          CollectionHelper.isPopulated(pc.contact.telephones)
        ) {
          pc.contact.telephones.forEach(t => {
            toReturn.push({
              id: t.number,
              label: t.number
            });
          });
        }
      });
    }

    if (CollectionHelper.isPopulated(otherContacts)) {
      otherContacts.forEach(c => {
        if (CollectionHelper.isPopulated(c.telephones)) {
          c.telephones.forEach(t => {
            toReturn.push({
              id: t.number,
              label: t.number
            });
          });
        }
      });
    }

    toReturn.push(IPBoardCustomBoardPhoneNumberPickerHelper.ALTERNATIVE);

    return toReturn;
  }

  static getSelectedPhoneNumberOption(
    phoneNumber: string,
    phoneNumberOptions: PhoneNumberOption[]
  ): PhoneNumberOption {
    if (
      StringHelper.isEmpty(phoneNumber) ||
      !CollectionHelper.isPopulated(phoneNumberOptions)
    ) {
      return null;
    }
    const seek = phoneNumberOptions.find(o => o.label === phoneNumber);
    return seek == null
      ? phoneNumberOptions[phoneNumberOptions.length - 1]
      : seek;
  }
}

export interface PhoneNumberOption {
  id: string;
  label: string;
}
